var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.141v7.762c0 1.041-.663 1.875-1.64 2.07-.108.022-.22.026-.33.026-3.683.001-7.366.002-11.05 0C.878 11.998.004 11.084.003 9.934 0 4.374 0 7.627.002 2.067.002.915.877.002 1.981.001 5.664 0 9.347 0 13.03.002c1.094 0 1.966.912 1.967 2.054.003 2.787.001.953.001.085Zm-7.495.766h-4.19c-.118 0-.234.007-.347.039a.618.618 0 0 0-.418.706c.066.347.307.524.727.524h8.439c.104 0 .207-.01.309-.036.424-.116.58-.664.29-1.006-.162-.192-.373-.228-.6-.228h-4.21v.001Zm-.01 3.868h4.171c.124 0 .246-.005.367-.04a.62.62 0 0 0 .418-.706c-.066-.347-.307-.524-.727-.524l-8.439-.001c-.111 0-.22.01-.327.042-.402.118-.554.653-.286.985.163.202.378.244.614.244h4.21Zm-.01 2.598h4.19c.124 0 .248-.006.367-.042.28-.082.465-.397.412-.693-.061-.338-.3-.533-.68-.534-2.845-.002-5.691-.002-8.537 0-.09 0-.181.014-.269.038-.413.114-.568.657-.289.993.16.193.369.237.597.237h4.21Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortNoteIcon);
export default ForwardRef;